import { For, Show } from "solid-js";
import { Panel } from "../layout/Panel.tsx";
import { deploys } from "../../stores/deploys.ts";
import { relTime } from "../../lib/relTime.ts";

export function DeployTimeline() {
  return (
    <Panel title="Deploys · GitHub" href="https://github.com/tedconf/zenith/actions" span="col-span-4">
      <Show when={deploys.recent.length > 0} fallback={<EmptyState />}>
        <ul class="space-y-1">
          <For each={deploys.recent.slice(0, 6)}>
            {(d) => (
              <li class="metric-inset flex items-center gap-2 px-3 py-2">
                <span class="font-mono text-[10px] font-bold text-[var(--color-info)]">
                  {d.sha?.slice(0, 7)}
                </span>
                <span class="flex-1 truncate font-mono text-[10px] text-[var(--color-text-secondary)]">
                  {d.title || d.ref}
                </span>
                <span class="font-mono text-[8px] text-[var(--color-text-dim)]">
                  {relTime(d.deployedAt)}
                </span>
              </li>
            )}
          </For>
        </ul>
      </Show>
    </Panel>
  );
}

function EmptyState() {
  return (
    <div class="flex h-full items-center justify-center">
      <div class="text-center">
        <div class="font-mono text-[10px] uppercase tracking-wider text-[var(--color-text-dim)]">
          Awaiting deploy events
        </div>
      </div>
    </div>
  );
}
